import React from "react";
import Content from "../sections/Login/Content";

export const Login = (props) => {
  return (
    <div className="ms-body ms-primary-theme ms-logged-out">
      <main className="body-content">
        <Content />
      </main>
    </div>
  );
};

export default Login;
